<template lang="pug">
transition( name='fade' appear )
  .overlay( v-show='overlay' ref='overlay' @click='close' )
</template>

<script lang="js">
import { mapActions, mapState } from 'vuex'
// import { Logger } from '@/lib/logger'

export default {
  name: 'overlay',
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions([ 'hideOverlay', 'closeModal', 'closeSidebar' ]),
    close( $event ) {
      if ( $event.target === this.$refs.overlay ) {
        if ( this.currentModal ) this.closeModal()
        if ( this.currentSidebar ) this.closeSidebar()
        if ( this.overlay ) this.hideOverlay()
      }
    }
  },
  computed: {
    ...mapState([ 'overlay', 'currentModal', 'currentSidebar' ])
  }
}
</script>

<style lang="scss">
.overlay {
  position: absolute;
  z-index: 10;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: var(--overlay-background, rgba(0,0,0,0.5));
}
</style>
